import { RegistrationStep } from '@/types/enums/forms/registration/registrationWizard';
import { isFeatureEnabled } from '@/config';

type StepOptions = Readonly<Partial<{ next: RegistrationStep; prev: RegistrationStep }>>;
type TransitionMap = Partial<Record<RegistrationStep, StepOptions>>;

const withIdentity: TransitionMap = {
    [RegistrationStep.PersonalDetails]: { next: RegistrationStep.ProfessionalDetails },
    [RegistrationStep.ProfessionalDetails]: {
        next: RegistrationStep.ContactDetails,
        prev: RegistrationStep.PersonalDetails,
    },
    [RegistrationStep.ContactDetails]: {
        next: RegistrationStep.Identity,
        prev: RegistrationStep.ProfessionalDetails,
    },
    [RegistrationStep.Identity]: {
        next: RegistrationStep.Address,
        prev: RegistrationStep.ContactDetails,
    },
    [RegistrationStep.Address]: { prev: RegistrationStep.Identity },
} as const;

const withoutIdentity: TransitionMap = {
    [RegistrationStep.PersonalDetails]: { next: RegistrationStep.ProfessionalDetails },
    [RegistrationStep.ProfessionalDetails]: {
        next: RegistrationStep.ContactDetails,
        prev: RegistrationStep.PersonalDetails,
    },
    [RegistrationStep.ContactDetails]: {
        next: RegistrationStep.Address,
        prev: RegistrationStep.ProfessionalDetails,
    },
    [RegistrationStep.Address]: { prev: RegistrationStep.ContactDetails },
} as const;

export const RegistrationMachine = {
    get transitions() {
        return isFeatureEnabled('registrationCompleteFlow') ? withoutIdentity : withIdentity;
    },
    getStepOptions(step: RegistrationStep): StepOptions {
        const map = this.transitions as TransitionMap;
        return map[step] ?? {};
    },
};
